module.exports = __webpack_public_path__ + "img/background-mobile-404.0c315a6b.jpg";